import React, { PropTypes } from "react";
import { connect } from "react-redux";
import ReactTimeout from "react-timeout";
import classNames from "classnames";
import { bindActionCreators } from "redux";

import * as dataActions from "../../../../../utils/data/dataActions";

class ClientAttachmentStatusToggler extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.toggleStatus = this.toggleStatus.bind(this);
  }

  toggleStatus() {
    const {
      afterToggle,
      dataActions,
      attachment: { clientAttachmentId, unread },
    } = this.props;
    const action = !!unread ? "read" : "unread";
    const model = {
      path: `/v1/client-attachments/${clientAttachmentId}/${action}`,
    };

    return dataActions.simplePost({ model }).then(() => {
      afterToggle();
    });
  }

  render() {
    const { unread } = this.props.attachment;
    const { disabled } = this.props;

    const actionLinkClasses = classNames({
      "action-icon": true,
      read: !unread,
      unread: !!unread,
      disableSpan: disabled
    });

    return (
      <span className="message-read-status">
        <span
          ref="action"
          className={actionLinkClasses}
          onClick={this.toggleStatus}
        />
      </span>
    );
  }
}

ClientAttachmentStatusToggler.propTypes = {
  afterToggle: PropTypes.func,
  attachment: PropTypes.object,
  dataActions: PropTypes.object,
  setTimeout: PropTypes.func,
  disabled: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ReactTimeout(ClientAttachmentStatusToggler));



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientAttachments/ClientAttachmentStatusToggler.js